import gsap from "gsap";


function homeAccordion() {
  
  if ($('#acc_menu').length) {
    $('#acc_menu').each(function () {
      const $this = $(this);
      const $catLength = $this.find('.accordion-title').length;
      if ($catLength <= 3) {
        $this.addClass('center')
      }
    })
  

    // Div count
    let mql = window.matchMedia("(max-width: 991px)");
    // Div over width
    const openItemWidthPercent = 64;
    //const acoitem = document.querySelectorAll("#acc_menu .item");
    const acoitems = document.querySelectorAll("#acc_menu .accordion-title");
    const acocontent = document.querySelectorAll("#acc_menu .accordion-content");
    const accordionId = document.querySelector("#acc_menu");
    // console.log(accordionId.length);
    const checkWidthSize = () => {
      if (mql.matches == false) {
        //console.log("desktop evertime");
        gsap.set(acocontent, { width: "0%" });
        gsap.set(acocontent, { clearProps: "height" });
      }
  
      if (mql.matches == true) {
        //console.log("mobile evertime");
        gsap.set(acocontent, { height: 0 });
        gsap.set(acocontent, { clearProps: "width" });
        accordionId.classList.remove("active-all");
        
        
      }
    }
    checkWidthSize();
    var windowResizeitem;
    
    var horWidth = $(window).width();
    window.addEventListener("resize", function() {
      var verWidth = $(window).width();
      if(verWidth !=  horWidth){
        clearTimeout(windowResizeitem);
        windowResizeitem = setTimeout(function() {
          //console.log("windowResizeitem");
          checkWidthSize();
        }, 250);  
      }
      
    });

    

    const totalItems = acoitems.length;

    acoitems.forEach((item) => {
      
      const checkWidthSizeItems = () => {
        if (mql.matches == false) {
          gsap.set(item, { width: 100 / totalItems + "%" });
        } else {
          gsap.set(item, { clearProps: "width" });
          accordionId.classList.remove("active-all");
        }
      }
      checkWidthSizeItems();

      var horWidthin = $(window).width();
      var windowCheckResizeitemsize;


      window.addEventListener("resize", function() {
        var verWidthin = $(window).width();
        if(verWidthin !=  horWidthin){
        clearTimeout(windowCheckResizeitemsize);
          windowCheckResizeitemsize = setTimeout(function() {
            //console.log("windowResizeitem");
            checkWidthSizeItems();
          }, 250);
        }  
      });
    
      item.addEventListener("click", () => {
        //Mobile device code
        if (mql.matches == true) {
          

          if (item.classList.contains("active")) {

            item.classList.remove("active");
            item.nextElementSibling.classList.remove("open");
            
            gsap.to(item.nextElementSibling, {
              height: 0,
              duration: 0.4,
              ease: "power2.out"
            });
            
            
          } else {
            console.log("mobile click touch");
            acoitems.forEach((elem) => elem.classList.remove("active"));
            item.classList.add("active");
            acocontent.forEach((elem) => elem.classList.remove("open"));
            item.nextElementSibling.classList.add("open");
            
            gsap.to(acocontent, {
              height: 0,
              duration: 0.4,
              ease: "power2.out"
            });

            gsap.to(item.nextElementSibling, {
              height: "auto",
              duration: 0.4,
              ease: "power2.out"
            });
            
            
            
            
            gsap.fromTo('.accordion-content.open .accordion-info > *, .accordion-content.open .readmore', {
              autoAlpha:0,
              yPercent: 50,
            },{
              autoAlpha:1,
              yPercent: 0,
              duration: .6,
              clearProps: "all",
              stagger: 0.15,
              ease: "power3.out",
              delay:.4,
            });
            
            
          }
          
        } else {
          //Desktop device code
          if (item.classList.contains("active")) {

            gsap.to('.accordion-info > *, .accordion-content .readmore', {
              autoAlpha:0,
              duration: 0.3,
              clearProps: "all",
            });

            gsap.to(acoitems, {
              width: 100 / totalItems + "%",
              duration: 0.4,
              ease: "power2.out"
            });
            gsap.to(item.nextElementSibling, {
              width: "0%",
              duration: 0.4,
              ease: "power2.out"
            });
            
            // gsap.to('.accordion-title', {
            //   width: "100%",
            //   duration: 0.4,
            //   ease: "power2.out"
            // });
            item.classList.remove("active");
            item.nextElementSibling.classList.remove("open");
            item.parentElement.classList.remove("active-all");
          } else {
            acoitems.forEach((elem) => elem.classList.remove("active"));
            item.classList.add("active");
            acocontent.forEach((elem) => elem.classList.remove("open"));

            item.nextElementSibling.classList.add("open");
            if (!item.parentElement.classList.contains("active-all")) {
              item.parentElement.classList.add("active-all");
            }

            

            gsap.to(acoitems, {
              width: (100 - openItemWidthPercent) / (totalItems - 1) + "%",
              duration: 0.6,
              ease: "power2.out"
            });
            
            //console.log(item.nextElementSibling.firstElementChild.querySelectorAll('*')); 
            //gsap.fromTo('.accordion-info > *, .accordion-content .readmore', {
            gsap.fromTo('.open .accordion-info > *, .open .readmore', {
              autoAlpha:0,
              yPercent: 50,
            },{
              autoAlpha:1,
              yPercent: 0,
              duration: .6,
              clearProps: "all",
              stagger: 0.15,
              ease: "power3.out",
              delay:.4,
            });
            
            gsap.to(acocontent, {
              width: "0%",
              duration: 0.6,
              ease: "power2.out"
            });
              
            gsap.to(item.nextElementSibling, {
              width: openItemWidthPercent + "%",
              duration: 0.6,
              ease: "power2.out",
              
            });
          }
        }
      });
    }); 
  }  
    
}

export default homeAccordion;

//module.exports = bannerSlider;